import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Menu } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import NotificationDropdown from './NotificationDropdown';

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { user } = useAuth();

  return (
    // Outer Container: Full Screen, No Window Scroll
    <div className="flex h-screen w-full bg-slate-50 overflow-hidden">
      
      {/* Sidebar is self-contained. We don't wrap it in a div that restricts it specifically, 
          we let the Sidebar component handle its dimensions. */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      {/* Main Content: Takes remaining width */}
      <div className="flex-1 flex flex-col min-w-0 h-full relative">
        
        {/* Header */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 shadow-sm flex-shrink-0 z-10">
          <button 
            className="lg:hidden p-2 rounded-md hover:bg-slate-100 text-slate-600"
            onClick={() => setIsSidebarOpen(true)}
          >
            <Menu className="w-6 h-6" />
          </button>

          <div className="hidden lg:block text-sm text-slate-500">
            Welcome back, <span className="font-semibold text-slate-800">{user?.full_name || 'Admin'}</span>
          </div>

          <div className="flex items-center space-x-4">
            <NotificationDropdown />
            <div className="h-8 w-8 rounded-full bg-airs-100 flex items-center justify-center border border-airs-200 text-airs-700 font-bold">
              {user?.full_name ? user.full_name[0] : 'A'}
            </div>
          </div>
        </header>

        {/* Scrollable Page Content */}
        <main className="flex-1 overflow-y-auto p-4 lg:p-8 bg-slate-50">
          <div className="max-w-9xl mx-auto pb-10">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;